module.exports = __webpack_public_path__ + "img/vanuatu.7713db5b.svg";